import React from "react";
import { Field, getIn } from "formik";
import { Error } from "@peracto/peracto-ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";

import { DayOfWeekPicker } from "./DayOfWeekPicker";
import { BranchSequenceBuilder } from "./BranchSequenceBuilder";

const TimeInput = ({ name, label, testId }) => (
    <Field name={name}>
        {({ field, form }) => {
            const error = getIn(form.errors, name);

            return (
                <div className="mb-3">
                    <label className="d-block mb-1">{label}</label>
                    <input
                        type="time"
                        step="1"
                        className="form-control"
                        data-testid={testId}
                        disabled={form.isSubmitting}
                        {...field}
                        value={field.value ?? ""}
                    />
                    {error && <Error error={error} name={label} />}
                </div>
            );
        }}
    </Field>
);

export const IBTSequenceRow = ({ name, index, onRemove, innerRef }) => (
    <div
        className="card"
        data-testid={`ibt-sequence-${index}`}
        ref={innerRef}
    >
        <div className="card-body">
            <div className="d-flex align-items-center justify-content-between mb-2">
                <h5 className="mb-0 font-weight-bold">Sequence {index + 1}</h5>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    data-testid={`ibt-sequence-${index}-remove`}
                    onClick={onRemove}
                >
                    <FontAwesomeIcon icon={faTrash} className="mr-1" />
                    Remove Sequence
                </button>
            </div>

            <div className="row">
                <div className="col-sm-6">
                    <TimeInput
                        name={`${name}.timeRangeStart`}
                        label="Time Range Start (HH:mm:ss)"
                        testId={`ibt-sequence-${index}-start`}
                    />
                </div>
                <div className="col-sm-6">
                    <TimeInput
                        name={`${name}.timeRangeEnd`}
                        label="Time Range End (HH:mm:ss)"
                        testId={`ibt-sequence-${index}-end`}
                    />
                </div>
            </div>
            <DayOfWeekPicker name={`${name}.daysOfWeek`} />

            <BranchSequenceBuilder name={`${name}.branchSequence`} />
        </div>
    </div>
);
